import i18n from "../i18n";
import { hasFullOpsAccess } from "../helpers/roles.js";
export default {
  data() {
    return {
      continents: [
        {
          id: "africa",
          name: i18n.t("africa"),
        },
        {
          id: "asia",
          name: i18n.t("asia"),
        },
        {
          id: "europe",
          name: i18n.t("europe"),
        },
        {
          id: "south_america",
          name: i18n.t("south_america"),
        },
        {
          id: "north_america",
          name: i18n.t("north_america"),
        },
        {
          id: "australia",
          name: i18n.t("australia"),
        },
      ],
      genders: [
        {
          id: "male",
          name: i18n.t("male"),
        },
        {
          id: "female",
          name: i18n.t("female"),
        },
      ],
    };
  },
  methods: {
    getRandomColor() {
      let colors = [
        {
          first: "#62EAE1",
          secound: "rgba(126, 229, 223, 0)",
        },
        {
          first: "#FF6370",
          secound: "rgba(255, 99, 112, 0)",
        },
        {
          first: "#9E62EA",
          secound: " #B199ED",
        },
        {
          first: "#EABC62",
          secound: "#E9BA62",
        },
      ];
      let random = Math.floor(Math.random() * 4);

      return { colors: colors[random], id: random };
    },
    errorImage(e, imageFalse) {
      e.target.src = imageFalse;
    },
    createRandomString() {
      const stringSpace =
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const stringLength = stringSpace.length;
      let randomString = "";
      for (let i = 0; i < 12; i++) {
        randomString =
          randomString + stringSpace[Math.floor(Math.random() * stringLength)];
      }
      return randomString;
    },
    helper_checkIfInputIsEmpty(e) {
      let inputElement = e.target;
      if (inputElement.value.length > 0) {
        inputElement.classList.remove("empty");
      } else {
        inputElement.classList.add("empty");
      }
    },

    helper_togglePasswordVisibility(e) {
      let passwordElement = e.currentTarget.parentElement.children[1];
      let passwordTogglerBtn = e.currentTarget;
      if (passwordElement.type == "password") {
        passwordElement.type = "text";
        passwordTogglerBtn.classList.add("password_is_visible");
      } else if (passwordElement.type == "text") {
        passwordElement.type = "password";
        passwordTogglerBtn.classList.remove("password_is_visible");
      }
    },

    helper_validEmail(email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    helper_filterSearch(value, search, item) {
      console.log(item);
      if (search == "all") return true;
      return value != null && search != null && value.indexOf(search) !== -1;
    },

    helper_containsObject(obj, arr, key) {
      console.log(arr);
      console.log(key);
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].uniqeID == obj.uniqeID) {
          console.log("the same element");
        } else {
          console.log("not the same");
        }
        // if (arr[i][key] !== obj[key]) {
        //   return true;
        // }
      }
      // return false;
    },

    //English
    isEnglish(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z0-9 ]+$/.test(char)) {
        return true;
      } else {
        e.preventDefault();
        this.$iziToast.error({
          timeout: 2000,
          displayMode: 2,
          message: this.$t("forms.validation.appLangEn"),
          position: "bottomRight",
        });
      }
    },
    inputLength(e) {
      let inputElement = e.target;
      if (inputElement.value.length >= 10) {
        e.preventDefault();
      }
    },
    isArabic(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[\u0621-\u064A0-9 ]+$/.test(char)) {
        return true;
      } else {
        e.preventDefault();
        this.$iziToast.error({
          timeout: 2000,
          displayMode: 2,
          message: this.$t("forms.validation.appLangAr"),
          position: "bottomRight",
        });
      }
    },

    // Global Action Permission Checker
    helper_hasPermission(action) {
      // 1. Check user type (superadmin & support have all permissions)
      // Prefer reactive Vuex store, fall back to localStorage
      if (hasFullOpsAccess(this.$store)) return true;

      // 2. Get permissions from Vuex store (injected via `this.$store`)
      // Fallback to localStorage if Vuex isn't fully ready
      let permissions = [];
      if (this.$store && this.$store.getters["permissions"]) {
        permissions = this.$store.getters["permissions"];
      } else {
        const stored = localStorage.getItem("Zoz_permissions");
        if (stored) permissions = JSON.parse(stored);
      }

      if (!permissions || !permissions.length) return false;

      // 3. Determine the base route resource name from the current route
      const currentPath = this.$route ? this.$route.path : "/";
      const pathSegs = currentPath.split("/").filter(Boolean);
      const isHome = !pathSegs.length || currentPath === "/";
      const baseResource = isHome ? "statistics" : pathSegs[0];

      // 4. Look for an exact match for the requested action and resource
      const isAllowed = permissions.some((p) => {
        const pUrl = (p.url || "").replace(/^\/+/, "").trim();
        const pRoute = (p.front_route_name || "").replace(/^\/+/, "").trim();
        const pBackRoute = (p.back_route_name || "").trim();

        // Exact match by back_route_name (e.g. "statistics.index", "countries.index")
        if (pBackRoute) {
          if (pBackRoute === action) return true;
          if (pBackRoute === `${baseResource}.${action}`) return true;
          if (
            isHome &&
            (pBackRoute === "statistics.index" || pBackRoute === "statistics")
          )
            return true;
        }

        // Exact match by url (e.g. "statistics/index", "country/delete")
        if (pUrl) {
          if (pUrl === `${baseResource}/${action}`) return true;
          if (pUrl === action) return true;
          if (isHome && (pUrl === "statistics" || pUrl === "statistics/index"))
            return true;
        }

        // Match by front_route_name alias
        if (pRoute) {
          if (isHome && (pRoute === "/" || pRoute === "")) {
            if (
              pBackRoute.includes("statistics") ||
              pUrl.includes("statistics")
            )
              return true;
          }
          if (
            pRoute === baseResource &&
            (pUrl.endsWith(`/${action}`) || pBackRoute.endsWith(`.${action}`))
          )
            return true;
        }

        return false;
      });

      return isAllowed;
    },
  },
};
